module.exports = {XMLHttpRequest:XMLHttpRequest};


//////////////////
// WEBPACK FOOTER
// external "{XMLHttpRequest:XMLHttpRequest}"
// module id = 823
// module chunks = 0